import { Component, EventEmitter, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Message } from '../../models/Message';
import { AuthService } from '../../services/auth.service';
import { CJHubService } from '../../services/cjhub.service';
import { SignalRService } from '../../services/signal-r.service';
import { SnackbarService } from '../../services/snackbar.service';
import { StateService } from '../../services/state.service';
import { MyConfigService } from '../../services/my-config.service';

@Component({
    selector: 'app-debug',
    templateUrl: './debugmodal.component.html',
    styleUrls: ['./debugmodal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DebugModalComponent implements OnInit, OnDestroy {
  onAdd = new EventEmitter();
  userTimedOutUserName = '';
  userAboutToGetTimedOut = false;
  whereImAt: string;
  step = 0;
  tokenExpires: any;
  JSON: JSON;
  isChecked = false;
  localStorageUsage: string;
  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    public dialogRef: MatDialogRef<any>,
    public signalRService: SignalRService,
    public cjHubService: CJHubService,
    public authService: AuthService,
    public router: Router,
    public stateService: StateService,
    public snackbarService: SnackbarService,
    public snackBar: MatSnackBar,
    public myConfigService: MyConfigService
  ) {
    this.JSON = JSON;
  }

  ngOnInit() {
    this.tokenExpires = this.tokenExpiresIn();
    this.getUserTimedOutObservable();
    this.getUserAboutToGetTimedOutObservable();
    this.dialogRef.updateSize('auto', 'auto');
    this.dialogRef.updatePosition({ top: '65px', bottom: '65px' });
    this.whereImAt = this.router.url;
    this.checkLocalStorage();
  }

  public toggle(event: MatSlideToggleChange) {
    this.signalRService.showTravelAgent(event.checked);
  }

  checkLocalStorage() {
    let localStorageTotal = 0,
      size: number,
      string: string;
    for (string in localStorage) {
      if (!localStorage.hasOwnProperty(string)) {
        continue;
      }
      size = (localStorage[string].length + string.length) * 2;
      localStorageTotal += size;
      // console.log(`${string.substr(0, 50)} = ${(size / 1024).toFixed(2)} KB`);
    }
    this.localStorageUsage = `Usage = ${(localStorageTotal / 1024).toFixed(2)} KB`;
  }

  tokenExpiresIn() {
    const tokenTime = moment(this.authService.getTokenExpirationDate());
    const now = moment(new Date());
    return now.to(tokenTime);
  }

  getUserTimedOutObservable() {
    this.authService
      .getUserTimedOutObservable()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(username => {
        this.userTimedOutUserName = username;
        // console.warn('Show login for ' + username);
      });
  }

  getUserAboutToGetTimedOutObservable() {
    this.authService
      .getUserAboutToGetTimedOutObservable()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(show => {
        this.userAboutToGetTimedOut = show;
      });
  }

  sendMessage(): void {
    const message = new Message();
    message.message = 'CJHUB';
    message.type = 'TEST';
    message.date = new Date();
    this.cjHubService.sendMessage(message);
  }

  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
  onCodeResult(resultString: string) {
    this.onAdd.emit('Closed Debug');
  }
  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
  refreshToken() {
    this.stateService.refreshToken();
  }
  refreshMyConfig() {
    this.stateService.getAndSetMyConfig();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
